// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"d7445cd3","132":"a57b6171","225":"71f7c38b","498":"01be2542","606":"79eaea08","626":"77098b47","697":"ab1deff8","996":"7c5ca842"}[chunkId] + ".js";
};